import {FOOTER_ACTION_REMOVE, FOOTER_ACTION_SET} from '../actions';
import {ActionWithPayload} from './index';
import {createSelector} from "@ngrx/store";
import {AppState} from "@store/reducers/index";

export interface FooterState {
  action: string,
}

export function footerReducer (
  state = {
    action: null
  }, action: ActionWithPayload<FooterState>) {
  switch (action.type) {

    case FOOTER_ACTION_SET:
      return {
        action: action.payload.action
      };

    case FOOTER_ACTION_REMOVE:
      return {
        action: null
      };

    default:
      return state;
  }
}

export const selectFooter = (state: AppState): FooterState => state.footer;

export const selectFooterAction = createSelector(
  selectFooter,
  (state: FooterState) => state.action
);



// WEBPACK FOOTER //
// ./src/app/store/reducers/footer.reducer.ts